import { RadioItem } from '../../forms';

export interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

export enum placeAddressComponent {
  ZIP_CODE = 'postal_code',
  COUNTRY = 'country',
  STATE = 'administrative_area_level_1',
  CITY = 'locality',
}

export function getAddressComponent(
  address_components: AddressComponent[],
  key: string,
  attribute?: 'long_name' | 'short_name',
) {
  if (!attribute) attribute = 'long_name';

  let value = '';
  const addressComponents = address_components?.filter((addressComponent) =>
    addressComponent.types.some((typesItem) => typesItem === key),
  );
  if (addressComponents && addressComponents.length > 0) value = addressComponents[0][attribute];
  return value;
}

export type AddressInformation = {
  company_address: string;
  company_address2: string;
  city: string;
  postal_or_zip_code: string;
  province_state: string;
  province_state_short: string;
  country: string;
  lat: number;
  lng: number;
};

interface PlaceAutocompleteStructuredFormat {
  main_text: string;
}

export interface PlaceAutocompletePrediction {
  description: string;
  place_id?: string;
  structured_formatting: PlaceAutocompleteStructuredFormat;
}

type PlacesResponseStatus =
  | 'OK'
  | 'ZERO_RESULTS'
  | 'INVALID_REQUEST'
  | 'OVER_QUERY_LIMIT'
  | 'REQUEST_DENIED'
  | 'UNKNOWN_ERROR';

type PlacesAutocompleteStatus = PlacesResponseStatus;
type PlaceDetailStatus = PlacesResponseStatus;

export interface PlacesAutocompleteResponse {
  predictions: PlaceAutocompletePrediction[];
  status: PlacesAutocompleteStatus;
  error_message?: string;
}

interface LocationComponent {
  lat?: number;
  lng?: number;
}

interface GeometryComponent {
  location?: LocationComponent;
}

interface Place {
  address_components?: AddressComponent[];
  formatted_address?: string;
  geometry?: GeometryComponent;
  place_id?: string;
}

export interface PlaceDetailsResponse {
  result: Place;
  status: PlaceDetailStatus;
}

export type AddressRadioItem = RadioItem<{
  placeId: string;
  mainAddress: string;
}>;

export const useAddress = () => {
  const formatAddresses = (predictions: PlaceAutocompletePrediction[]) => {
    return predictions.map((prediction) => {
      const address: AddressRadioItem = {
        title: prediction.description,
        value: {
          placeId: prediction.place_id,
          mainAddress: prediction.structured_formatting?.main_text,
        },
        single: true,
        selected: false,
      };

      return address;
    });
  };

  const getAddressComponents = (addressComponents: AddressComponent[]) => {
    const city = getAddressComponent(addressComponents, placeAddressComponent.CITY);
    const postalCode = getAddressComponent(addressComponents, placeAddressComponent.ZIP_CODE);
    const state = getAddressComponent(addressComponents, placeAddressComponent.STATE, 'long_name');
    const state_short = getAddressComponent(addressComponents, placeAddressComponent.STATE, 'short_name');
    const country = getAddressComponent(addressComponents, placeAddressComponent.COUNTRY, 'short_name');

    return {
      city,
      postalCode,
      state,
      state_short,
      country,
    };
  };

  return { formatAddresses, getAddressComponents };
};
